import $ from 'jquery';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';

window.jQuery = window.$ = $;

/** ===============

 .. Instagram carousel

 =============== */

$(function () {

    "use strict";

    /*------------------------------------------------------------------------------*/
    /* Instagram carousel
    /*------------------------------------------------------------------------------*/

    if (!$('.instagram-carousel').length) return;

    $('body').append(
        '<div class="modal fade" id="instagramLightbox" tabindex="-1" aria-hidden="true">' +
            '<div class="modal-dialog modal-dialog-centered modal-lg">' +
                '<div class="modal-content bg-transparent border-0 shadow-none">' +
                    '<button type="button" class="btn-close btn-close-white position-absolute top-0 end-0 m-3" style="z-index:1" data-bs-dismiss="modal" aria-label="Close"></button>' +
                    '<div class="modal-body p-0 text-center position-relative">' +
                        '<img src="" class="mfp-img rounded" alt="">' +
                        '<button type="button" class="mfp-arrow mfp-arrow-left" aria-label="Previous"></button>' +
                        '<button type="button" class="mfp-arrow mfp-arrow-right" aria-label="Next"></button>' +
                        '<div class="mfp-dots"></div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>'
    );

    var $modal = $('#instagramLightbox');
    var modal = new bootstrap.Modal($modal[0]);
    var currentItems = [];
    var currentIndex = 0;

    function showSlide(index) {
        currentIndex = (index + currentItems.length) % currentItems.length;
        $modal.find('.mfp-img').attr('src', currentItems[currentIndex].src);
        $modal.find('.mfp-dot').removeClass('mfp-dot-active');
        $modal.find('.mfp-dot[data-index="' + currentIndex + '"]').addClass('mfp-dot-active');
    }

    function openLightbox(items, startIndex) {
        currentItems = items;

        var $dots = $modal.find('.mfp-dots').empty();
        items.forEach(function (_, i) {
            $dots.append('<button type="button" class="mfp-dot' + (i === startIndex ? ' mfp-dot-active' : '') + '" aria-label="post ' + i + '" data-index="' + i + '"></button>');
        });

        $modal.find('.mfp-arrow').toggle(items.length > 1);
        showSlide(startIndex);
        modal.show();
    }

    $('.instagram-carousel').each(function () {
        var $carousel = $(this);
        var items = [];

        $carousel.find('a').each(function () {
            items.push({
                src: $(this).attr('href'),
                permalink: $(this).attr('data-permalink')
            });
        });

        $carousel.find('.single-instagram-post')
            .on('click', function (e) {
                e.preventDefault();
                openLightbox(items, 0);
            })
            .on('auxclick', function (e) {
                if (e.button === 1) {
                    e.preventDefault();
                    window.open($(this).attr('data-permalink'));
                }
            });
    });

    $modal.on('click', '.mfp-arrow-left', function () {
        showSlide(currentIndex - 1);
    });

    $modal.on('click', '.mfp-arrow-right', function () {
        showSlide(currentIndex + 1);
    });

    $modal.on('click', '.mfp-dot', function () {
        showSlide(Number($(this).attr('data-index')));
    });

    $modal.on('click', '.mfp-img', function () {
        if (currentItems[currentIndex] && currentItems[currentIndex].permalink) {
            window.open(currentItems[currentIndex].permalink);
        }
    });

    $(document).on('keydown', function (e) {
        if (!$modal.hasClass('show')) return;
        if (e.key === 'ArrowLeft') showSlide(currentIndex - 1);
        if (e.key === 'ArrowRight') showSlide(currentIndex + 1);
    });

    $modal.on('show.bs.modal', function () {
        $('body').addClass('mfp-opened mfp-carousel-opened');
    });

    $modal.on('hidden.bs.modal', function () {
        $('body').removeClass('mfp-opened mfp-carousel-opened');
        $modal.find('.mfp-img').attr('src', '');
    });
});
